import {SmartComponent} from "smart-component-js";


class TelInputComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element
        this.init();
    }


    init() {
        const input = this.element.querySelector('input[name="phone"]');
        window.intlTelInput(input, {
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js",
            formatOnDisplay: false,
            nationalMode: false,
            showFlags: false,
            autoPlaceholder: 'polite',
            separateDialCode: true,
            formatAsYouType: false,
            initialCountry: "auto",
            geoIpLookup: function (success, failure) {
                fetch("https://ipapi.co/json")
                    .then(function (res) { return res.json(); })
                    .then(function (data) { success(data.country_code); })
                    .catch(function () { failure(); });
            }
        });
    }
}

export default TelInputComponent;
